import type { Translation } from '../../types';
import type { modules as en } from '../en/modules';

/** Cài đặt › Module: các module kết nối theo từng mảng nghiệp vụ. Lời thường, không dùng mã. */
export const modules: Translation<typeof en> = {
  page: {
    title: 'Module',
    subtitle:
      'Mọi dịch vụ bên ngoài mà hệ thống dùng, xếp theo mảng nghiệp vụ. Thêm kết nối, điền cài đặt, kiểm tra kết nối rồi bật; trên máy chủ chính thức, mỗi thay đổi cần người thứ hai duyệt.',
    areas: 'Mảng nghiệp vụ',
    skipAreas: 'Chuyển tới nội dung mảng đang mở',
    loadFailed: 'Không tải được danh sách module',
    backTo: 'Quay lại {{branch}}',
  },
  branch: {
    registry: 'Tên miền',
    payment: 'Thanh toán',
    notify: 'Thông báo',
    einvoice: 'Hoá đơn điện tử',
    captcha: 'Chống robot',
    signing: 'Ký số',
    ekyc: 'eKYC',
    ocr: 'Đọc giấy tờ (OCR)',
    regulatory: 'Báo cáo VNNIC',
    lookup: 'Tra cứu tên miền',
    escrow: 'Ký quỹ dữ liệu',
    dns: 'DNS',
    hosting: 'Hosting',
    email: 'Email doanh nghiệp',
    cloud: 'Cloud, VPS',
    website: 'Website',
    addons: 'Tiện ích',
  },
  branchHint: {
    registry: 'Registry và nhà đăng ký đối tác: đăng ký, gia hạn, chuyển tên miền.',
    payment: 'Nhà cung cấp thanh toán (SePay, Casso, TinoPay, VNPAY…): mã QR chuyển khoản, nhận báo tiền vào và đối chiếu với đơn hàng, hoá đơn.',
    notify: 'E-mail và tin Zalo gửi khách hàng và nhân viên.',
    einvoice: 'Hoá đơn điện tử phát hành qua nhà cung cấp hoá đơn.',
    captcha: 'Bước xác minh "không phải robot" ở trang đăng nhập và đăng ký của khách.',
    signing: 'Chữ ký số của nhà đăng ký trên bản khai tên miền và các tệp.',
    ekyc: 'Xác minh danh tính chủ thể: giấy tờ tuỳ thân và khuôn mặt.',
    ocr: 'Đọc giấy tờ tuỳ thân và bản khai, chỉ trên máy chủ của chúng ta.',
    regulatory: 'Báo cáo và hồ sơ tên miền gửi VNNIC.',
    lookup: 'Tên miền còn trống không và ai đang giữ (WHOIS).',
    escrow: 'Bản sao dữ liệu đăng ký gửi đơn vị ký quỹ.',
    dns: 'Máy chủ DNS cho tên miền của khách.',
    hosting: 'Tài khoản hosting web.',
    email: 'Tài khoản e-mail doanh nghiệp.',
    cloud: 'Máy chủ cloud và VPS.',
    website: 'Công cụ làm website và website được quản lý.',
    addons: 'Tính năng bổ sung cài thêm vào hệ thống.',
  },
  branchTab: {
    modules: 'Module',
    noModules: 'Chưa có module nào',
    noModulesHint: 'Mảng này chưa kết nối nhà cung cấp nào. Khi có module của một nhà cung cấp, module đó hiện ở đây để thêm kết nối.',
    coreSettings: 'Cài đặt chung của mảng',
    coreSettingsHint: 'Quy tắc của chính mảng này, dùng chung cho mọi module; thay đổi và duyệt như mọi cài đặt.',
    coreEdit: 'Sửa',
    coreDefaults: 'Chưa lưu gì: đang dùng giá trị mặc định.',
    coreValues: 'Xem giá trị đang dùng',
    summary_one: '{{count}} module',
    summary_other: '{{count}} module',
    summaryOn_one: '{{on}}/{{count}} kết nối đang bật',
    summaryOn_other: '{{on}}/{{count}} kết nối đang bật',
    legacyTitle: 'Kết nối cấu hình ở trang riêng',
    legacyHint: 'Các dịch vụ này chưa thành module. Chúng giữ trang cài đặt riêng cho đến khi được chuyển thành module.',
    legacyConfigured: 'Đã cấu hình (phiên bản {{version}})',
    legacyNotConfigured: 'Chưa cấu hình trong trang quản trị (dùng cài đặt của máy chủ)',
    openPage: 'Mở trang cài đặt',
    connectionsTitle: 'Kết nối registry',
    connectionsHint: 'Mỗi kết nối có trang riêng: địa chỉ, thông tin đăng nhập, chứng chỉ và các đuôi tên miền nó đăng ký.',
    connectionsNone: 'Chưa có kết nối registry nào.',
    connectionColumns: { name: 'Kết nối', kind: 'Loại', protocol: 'Cách kết nối', module: 'Module', status: 'Trạng thái' },
  },
  card: {
    vendor: 'Nhà cung cấp',
    version: 'Module phiên bản {{version}}',
    versionShort: 'v{{version}}',
    capabilities: 'Làm được gì',
    noCapabilities: 'Những việc mọi module của mảng đều làm.',
    documents: 'Tài liệu của nhà cung cấp',
    filedDocument: 'Lưu cùng hệ thống: {{path}}',
    instances: 'Kết nối',
    noInstances: 'Chưa có kết nối nào: thêm một kết nối để dùng module này.',
    add: 'Thêm kết nối',
    limit_one: '{{used}} kết nối · tối đa {{count}}',
    limit_other: '{{used}} kết nối · tối đa {{count}}',
    open: 'Mở',
    switchOn: 'Bật',
    switchOff: 'Tắt',
    notProductionReady: 'Chỉ dùng để phát triển và kiểm thử: không bật được trên máy chủ chính thức.',
    versionInForce: 'Đang dùng phiên bản {{version}}',
    noVersion: 'Chưa có phiên bản đang dùng',
  },
  instanceColumns: { name: 'Kết nối', status: 'Trạng thái', health: 'Tình trạng', test: 'Kiểm tra gần nhất', actions: '' },
  status: {
    NEW: 'Chưa thiết lập',
    DRAFT: 'Bản nháp',
    TESTED: 'Bản nháp đã kiểm tra',
    PENDING: 'Chờ duyệt',
    ACTIVE: 'Đang bật',
    DISABLED: 'Đang tắt',
  },
  statusHint: {
    NEW: 'Chưa lưu gì.',
    DRAFT: 'Đã lưu bản nháp; cần kiểm tra kết nối trước khi bật.',
    TESTED: 'Bản nháp đã qua kiểm tra kết nối trong 24 giờ qua và có thể áp dụng.',
    PENDING: 'Có thay đổi đang chờ người thứ hai duyệt.',
    ACTIVE: 'Kết nối đang được dùng.',
    DISABLED: 'Kết nối đang tắt.',
  },
  health: {
    healthy: 'Hoạt động tốt',
    degraded: 'Có lỗi',
    down: 'Không hoạt động',
    unknown: 'Chưa có dữ liệu',
  },
  healthHint: {
    healthy: 'Lần kiểm tra gần nhất đạt và các lần gọi gần đây đều thành công.',
    degraded: 'Lần kiểm tra gần nhất không đạt hoặc nhiều lần gọi gần đây bị lỗi.',
    down: 'Có dịch vụ không nạp được kết nối này.',
    unknown: 'Đang tắt, hoặc chưa kiểm tra và chưa gọi lần nào.',
  },
  versionStatus: {
    DRAFT: 'Bản nháp',
    PENDING_APPROVAL: 'Chờ duyệt',
    ACTIVE: 'Đang dùng',
    SUPERSEDED: 'Đã thay',
    REJECTED: 'Bị từ chối',
    CANCELLED: 'Đã huỷ',
  },
  instance: {
    title: '{{module}} · {{instance}}',
    coreTitle: 'Cài đặt chung · {{branch}}',
    defaultName: 'Kết nối chính',
    loadFailed: 'Không tải được kết nối này',
    tabs: {
      overview: 'Tổng quan',
      config: 'Cấu hình',
      test: 'Kiểm tra kết nối',
      callback: 'Callback',
      logs: 'Nhật ký',
      actions: 'Thao tác',
      pages: 'Trang nghiệp vụ',
    },
    overview: {
      state: 'Trạng thái',
      enabled: 'Đang bật',
      generation: 'Lần thay đổi cấu hình',
      inForce: 'Phiên bản đang dùng',
      noneInForce: 'Chưa có phiên bản nào được dùng',
      activatedBy: 'Áp dụng bởi {{who}}',
      displayName: 'Tên',
      key: 'Mã kết nối',
      applied: 'Dịch vụ đang dùng',
      appliedHint: 'Các dịch vụ đã nạp kết nối này trong 10 phút qua.',
      appliedNone: 'Chưa dịch vụ nào nạp kết nối này trong 10 phút qua.',
      upToDate: 'Đã cập nhật',
      formerSubject: 'tên cũ',
      formerSubjectHint: 'Dịch vụ này báo cáo theo tên kết nối cũ ({{subject}}), trước khi chuyển sang mô-đun.',
      behind: 'Còn cấu hình cũ',
      module: 'Về module',
      vendor: 'Nhà cung cấp',
      moduleVersion: 'Phiên bản module',
      data: 'Dữ liệu xử lý',
      egress: 'Kết nối tới đâu',
      disable: 'Khi tắt',
      instances: 'Số kết nối cho phép',
      testPolicy: 'Kiểm tra kết nối',
      jobs: 'Việc chạy theo lịch',
      events: 'Sự kiện báo về',
      noJobs: 'Không có',
      everySeconds: 'mỗi {{count}} giây',
      everyMinutes: 'mỗi {{count}} phút',
      everyHours: 'mỗi {{count}} giờ',
      dailyAt: 'hằng ngày vào giờ ở mục "{{setting}}" (mặc định {{time}})',
    },
    source: {
      DATABASE: 'Cài đặt từ trang quản trị',
      ENVIRONMENT: 'Cài đặt của máy chủ (biến môi trường)',
      DISABLED: 'Đang tắt',
    },
    loadError: {
      RESTART_REQUIRED: 'Cần khởi động lại để dùng cài đặt mới',
      SECRET_UNAVAILABLE: 'Không đọc được thông tin bí mật',
      CONFIGURATION_INVALID: 'Module không chấp nhận cài đặt',
      SETTINGS_UNAVAILABLE: 'Không đọc được cài đặt',
      other: 'Không nạp được cài đặt',
    },
  },
  data: { public: 'Chỉ dữ liệu công khai', personal: 'Dữ liệu cá nhân', regulated: 'Dữ liệu theo quy định (VNNIC, danh tính)' },
  egress: {
    hosts: 'Chỉ các địa chỉ: {{hosts}}',
    from_setting: 'Chỉ máy chủ mà kết nối ghi ({{setting}})',
    local_only: 'Không đi đâu: chạy trên máy chủ của chúng ta',
    none: 'Không kết nối ra ngoài',
  },
  disable: {
    immediate: 'Tắt ngay, một người làm được',
    needs_approval: 'Trên máy chủ chính thức cần người thứ hai duyệt (tắt là bỏ một lớp bảo vệ)',
  },
  instancesPolicy: { one: 'Một', many: 'Tối đa {{max}}' },
  testPolicy: { steps: 'Các bước: {{steps}}', no_test: 'Không có: {{reason}}' },
  config: {
    inForce: 'Đang dùng',
    draft: 'Bản nháp',
    pending: 'Chờ duyệt',
    nothing: 'Chưa lưu gì. Điền cài đặt để tạo bản nháp.',
    edit: 'Sửa cài đặt',
    create: 'Điền cài đặt',
    test: 'Kiểm tra bản nháp này',
    propose: 'Áp dụng bản nháp này',
    proposeProduction: 'Gửi duyệt',
    proposeNeedsTest: 'Cần kiểm tra kết nối bản nháp này trước (đạt trong 24 giờ qua).',
    tested: 'Đã kiểm tra đạt trong 24 giờ qua',
    notTested: 'Chưa kiểm tra',
    noTestNeeded: 'Module này không có bước kiểm tra kết nối',
    secrets: 'Thông tin bí mật',
    reason: 'Lý do',
    savedBy: 'Lưu bởi {{who}}',
    history: 'Lịch sử phiên bản',
    historyNone: 'Chưa có phiên bản nào.',
    newer: 'Mới hơn',
    older: 'Cũ hơn',
    columns: { version: 'Phiên bản', status: 'Trạng thái', enabled: 'Bật', values: 'Cài đặt', reason: 'Lý do', by: 'Người làm' },
    approval: 'Phê duyệt',
    enabledField: 'Đang bật',
    unset: 'Chưa đặt (dùng mặc định)',
    advanced: 'Nâng cao',
    group: { other: 'Cài đặt khác' },
  },
  form: {
    title: 'Cài đặt {{name}}',
    description: 'Lưu sẽ tạo bản nháp. Khách hàng chưa bị ảnh hưởng cho đến khi bản nháp được kiểm tra và áp dụng.',
    enabled: 'Bật kết nối',
    enabledHint: 'Tắt: hệ thống không dùng kết nối này.',
    displayName: 'Tên hiển thị cho nhân viên',
    displayNameHint: 'Không bắt buộc, ví dụ tài khoản ngân hàng mà kết nối đọc.',
    required: 'Bắt buộc',
    requiredWhenOn: 'Bắt buộc khi bật',
    optional: 'Không bắt buộc',
    defaultValue: 'Mặc định: {{value}}',
    useDefault: 'Dùng giá trị mặc định',
    maxLength: 'Tối đa {{count}} ký tự',
    pattern: 'Phải đúng định dạng',
    httpsOnly: 'Chỉ nhận địa chỉ https://',
    range: 'Từ {{min}} đến {{max}}',
    timeHint: 'Giờ Việt Nam (giờ:phút)',
    phoneHint: 'Số di động kèm mã nước, không có dấu +, ví dụ 84912345678',
    pathHint: 'Đường dẫn bắt đầu bằng /, ví dụ /api/v1/list',
    emailHint: 'Một địa chỉ e-mail',
    certificateHint: 'Tệp chứng thư (PEM). Khoá riêng không bao giờ được hiển thị lại.',
    certificateWithKey: 'Chứng thư kèm khoá riêng (PEM). Khoá không bao giờ được hiển thị lại.',
    fileHint: 'Loại tệp nhận: {{types}}; tối đa {{size}}.',
    fileTooBig: 'Tệp lớn hơn {{size}}.',
    fileRead: 'Đã đọc {{name}} ({{size}}). Nội dung không được hiển thị.',
    choose: 'Chọn…',
    loadOptions: 'Lấy danh sách lựa chọn từ nhà cung cấp',
    optionsUnavailable: 'Danh sách lựa chọn lấy được khi kết nối đã bật; trong lúc chờ hãy nhập giá trị.',
    secretPermission: 'Đổi thông tin bí mật cần quyền quản lý thông tin đăng nhập.',
    keep: 'Giữ giá trị hiện tại',
    saveDraft: 'Lưu bản nháp',
    cancel: 'Huỷ',
    close: 'Đóng',
    saved: 'Đã lưu bản nháp (phiên bản {{version}}).',
    nextSteps: 'Tiếp theo: kiểm tra kết nối bản nháp này rồi áp dụng.',
    nextStepsNoTest: 'Tiếp theo: áp dụng bản nháp.',
    errors: {
      REQUIRED: 'Cần nhập',
      TOO_LONG: 'Quá dài',
      PATTERN: 'Không đúng định dạng',
      NOT_IN_OPTIONS: 'Không có trong danh sách lựa chọn',
      HTTPS_REQUIRED: 'Phải bắt đầu bằng https://',
      INVALID_URL: 'Không phải địa chỉ web hợp lệ',
      OUT_OF_RANGE: 'Ngoài khoảng cho phép',
      INVALID_TIME: 'Không phải giờ (giờ:phút)',
      INVALID_EMAIL: 'Không phải địa chỉ e-mail',
      INVALID_PHONE: 'Không phải số điện thoại kèm mã nước',
      INVALID_PATH: 'Không phải đường dẫn bắt đầu bằng /',
      NOT_A_NUMBER: 'Không phải số nguyên',
    },
  },
  fieldType: {
    text: 'Chữ',
    secret: 'Thông tin bí mật (chỉ nhập, không xem lại)',
    select: 'Chọn một',
    multi_select: 'Chọn nhiều',
    url: 'Địa chỉ web',
    path: 'Đường dẫn',
    integer: 'Số',
    boolean: 'Bật / tắt',
    time_of_day: 'Giờ trong ngày',
    email: 'Địa chỉ e-mail',
    phone: 'Số điện thoại',
    certificate: 'Chứng thư',
    file: 'Tệp',
  },
  unit: { ms: 'mili giây', seconds: 'giây', minutes: 'phút', vnd: 'đồng', records: 'bản ghi', attempts: 'lần', percent: '%' },
  propose: {
    title: 'Áp dụng phiên bản {{version}}',
    description: 'Bản nháp đã kiểm tra sẽ thay phiên bản đang dùng.',
    descriptionProduction: 'Bản nháp được gửi cho người thứ hai duyệt; duyệt xong mới được áp dụng.',
    changes: 'Thay đổi',
    noChanges: 'Không khác gì phiên bản đang dùng.',
  },
  toggle: {
    offTitle: 'Tắt {{name}}',
    onTitle: 'Bật {{name}}',
    offDescription: 'Hệ thống ngừng dùng kết nối này.',
    offApproval: 'Trên máy chủ chính thức, tắt module này cần người thứ hai duyệt vì nó bỏ một lớp bảo vệ.',
    onDescription: 'Bật lại phiên bản gần nhất. Nếu phiên bản đó chưa qua kiểm tra trong 24 giờ qua, nó được lưu thành bản nháp để kiểm tra trước.',
    testRequired: 'Đã lưu thành bản nháp: hãy kiểm tra kết nối rồi áp dụng.',
  },
  create: {
    title: 'Thêm kết nối cho {{module}}',
    description: 'Mỗi kết nối có cài đặt, thông tin bí mật, kiểm tra và nhật ký riêng. Module cho phép nhiều kết nối có thể phục vụ, ví dụ, nhiều tài khoản ngân hàng.',
    key: 'Mã kết nối',
    keyHint: 'Chữ thường, chữ số và dấu "-", ví dụ default, acb-2. Mã nằm trong địa chỉ callback và không đổi được.',
    displayName: 'Tên hiển thị cho nhân viên',
    created: 'Đã thêm kết nối {{key}}. Tiếp theo hãy điền cài đặt.',
    open: 'Mở kết nối',
  },
  test: {
    title: 'Kiểm tra kết nối',
    hint: 'Bài kiểm tra dùng phiên bản được chọn mà không áp dụng nó. Mỗi kết nối kiểm tra tối đa một lần mỗi 10 giây.',
    run: 'Chạy kiểm tra',
    running: 'Đang kiểm tra…',
    version: 'Phiên bản cần kiểm tra',
    versionOf: {
      draft: 'Bản nháp (phiên bản {{version}})',
      pending: 'Đang chờ duyệt (phiên bản {{version}})',
      active: 'Đang dùng (phiên bản {{version}})',
    },
    nothingToTest: 'Hãy lưu bản nháp trước.',
    none: 'Chưa kiểm tra lần nào.',
    history: 'Các lần kiểm tra gần đây',
    outcome: { OK: 'Đạt', FAILED: 'Không đạt' },
    stepOutcome: { OK: 'Đạt', FAILED: 'Không đạt', SKIPPED: 'Không chạy' },
    step: {
      REACHABILITY: 'Kết nối tới nhà cung cấp',
      TOKEN: 'Lấy mã truy cập',
      API_CALL: 'Một lệnh chỉ đọc',
      SIGNATURE: 'Kiểm tra chữ ký',
      SEND_TO_ADMIN: 'Gửi tin cho quản trị viên',
    },
    forVersion: 'Phiên bản {{version}}',
    duration: '{{ms}} mili giây',
    rateLimited: 'Chờ {{seconds}} giây rồi kiểm tra lại.',
  },
  failure: {
    TIMEOUT: 'Không trả lời kịp',
    DNS: 'Không tìm thấy địa chỉ',
    CONNECT: 'Không kết nối được',
    TLS: 'Không lập được kết nối bảo mật (chứng chỉ)',
    BAD_ANSWER: 'Không đọc được câu trả lời',
    CONFIGURATION: 'Cài đặt chưa đủ hoặc chưa đúng',
    RATE_LIMITED: 'Gửi quá nhiều: nhà cung cấp yêu cầu chờ',
    EGRESS_REFUSED: 'Module này không được phép kết nối tới địa chỉ đó',
    PROVIDER_ERROR: 'Nhà cung cấp bị lỗi',
  },
  refusal: {
    NOT_FOUND: 'Nhà cung cấp không tìm thấy',
    ALREADY_EXISTS: 'Đã có ở nhà cung cấp',
    UNAUTHORIZED: 'Nhà cung cấp không chấp nhận thông tin đăng nhập',
    IP_NOT_ALLOWED: 'Nhà cung cấp không nhận yêu cầu từ địa chỉ của máy chủ này',
    INVALID_REQUEST: 'Nhà cung cấp cho là yêu cầu không hợp lệ',
    CONFLICT: 'Nhà cung cấp từ chối vì trái với tình trạng hiện tại',
    QUOTA_EXCEEDED: 'Đã hết hạn mức ở nhà cung cấp',
    INSUFFICIENT_FUNDS: 'Số dư ở nhà cung cấp không đủ',
    RATE_LIMITED: 'Gửi quá nhiều: nhà cung cấp yêu cầu chờ',
    MAINTENANCE: 'Nhà cung cấp đang bảo trì',
    UNSUPPORTED: 'Nhà cung cấp không có việc này',
  },
  otherCode: 'Câu trả lời khác của nhà cung cấp',
  callback: {
    title: 'Địa chỉ callback',
    none: 'Module này không nhận callback từ nhà cung cấp.',
    path: 'Địa chỉ cần nhập ở trang của nhà cung cấp',
    pathHint: 'Ghép địa chỉ công khai của API hệ thống vào trước đường dẫn này, ví dụ https://api.example.vn{{path}}.',
    limits: 'Mỗi lần gọi, nhà cung cấp gửi tối đa {{size}}; hệ thống trả lời trong {{seconds}} giây.',
    security: 'Mọi lần gọi đều được kiểm tra (chữ ký hoặc khoá) trước khi đọc; lần gọi không qua kiểm tra bị từ chối và không được lưu.',
    method: 'Nhà cung cấp gọi bằng POST, dữ liệu nằm trong nội dung yêu cầu.',
    methodGet: 'Nhà cung cấp gọi bằng GET, dữ liệu nằm trên địa chỉ (sau dấu ?); hệ thống cũng nhận POST.',
    setup: 'Cách thiết lập ở trang của nhà cung cấp',
    receipts: 'Các lần nhận',
    receiptsHint: 'Chỉ những lần gọi đã qua kiểm tra; nội dung không bao giờ được lưu, chỉ lưu dấu vân tay và các mã tham chiếu kèm theo.',
    receiptsNone: 'Chưa nhận lần nào.',
    receiptOutcome: { PROCESSED: 'Đã xử lý', DUPLICATE: 'Đã nhận trước đó', MALFORMED: 'Không đọc được', FAILED: 'Lỗi' },
    columns: { at: 'Lúc nhận', outcome: 'Kết quả', ids: 'Mã tham chiếu', size: 'Dung lượng', status: 'Trả lời', duration: 'Thời gian' },
  },
  logs: {
    calls: 'Các lần gọi nhà cung cấp',
    callsHint: 'Mỗi lần hệ thống gọi nhà cung cấp qua kết nối này, không kèm nội dung.',
    callsNone: 'Chưa gọi lần nào.',
    callOutcome: { ok: 'Thành công', refused: 'Nhà cung cấp từ chối', not_sent: 'Chưa gửi được', unknown: 'Không rõ kết quả' },
    columns: { at: 'Lúc', operation: 'Việc', outcome: 'Kết quả', code: 'Mã', duration: 'Thời gian', version: 'Phiên bản module' },
    operation: { test: 'Kiểm tra kết nối', action: 'Thao tác: {{name}}', other: 'Việc khác' },
    audit: 'Nhật ký thao tác của kết nối này',
    more: 'Cũ hơn',
    newest: 'Mới nhất',
  },
  actions: {
    title: 'Thao tác',
    hint: 'Các thao tác module cung cấp trên kết nối đang dùng. Thao tác làm thay đổi dữ liệu được ghi vào nhật ký thao tác.',
    none: 'Module này không có thao tác nào.',
    run: 'Chạy',
    running: 'Đang chạy…',
    readOnly: 'Chỉ đọc',
    changes: 'Có thay đổi',
    needs: 'Cần quyền: {{permission}}',
    needsOn: 'Dùng được khi kết nối đã bật.',
    result: 'Kết quả',
    outcome: { ok: 'Đã xong', refused: 'Nhà cung cấp từ chối', not_sent: 'Chưa gửi được', unknown: 'Không rõ kết quả' },
    empty: 'Không có dữ liệu',
  },
  pages: {
    title: 'Trang nghiệp vụ',
    hint: 'Các trang của hệ thống dùng module này.',
    none: 'Module này không có trang riêng.',
    open: 'Mở',
    missing: 'Phiên bản trang quản trị này chưa có trang đó.',
  },
  hosting: {
    intro: 'Những gì máy chủ của kết nối này đang giữ: các máy chủ và sức chứa, các tài khoản (đánh dấu tài khoản chưa có trong hệ thống) và các gói. Mỗi lần đọc máy chủ là một dòng trong Nhật ký.',
    servers: 'Máy chủ',
    serversHint: 'Theo cách hệ thống xếp chỗ: báo cáo gần nhất của máy chủ cộng các tài khoản đã xếp từ đó. Máy chủ ngừng nhận tài khoản mới vẫn giữ tài khoản đang có.',
    serversNone: 'Chưa có máy chủ nào được báo về: bấm làm mới từ máy chủ.',
    serverCol: { server: 'Máy chủ', accounts: 'Tài khoản', disk: 'Đĩa trống', up: 'Hoạt động', accepting: 'Tài khoản mới', checked: 'Lần báo gần nhất', note: 'Ghi chú' },
    accountsOf: '{{accounts}} / {{max}}',
    pendingOf: '+{{count}} vừa xếp chỗ',
    diskGb: '{{value}} GB',
    upYes: 'Đang chạy',
    upNo: 'Không chạy',
    gone: 'Không còn được báo về',
    acceptingYes: 'Đang nhận',
    acceptingNo: 'Đã ngừng nhận',
    refresh: 'Làm mới từ máy chủ',
    refreshTitle: 'Đọc lại danh sách máy chủ',
    refreshIntro: 'Đọc ngay các máy chủ và sức chứa trên bảng điều khiển (hệ thống tự làm 15 phút một lần).',
    refreshDone: 'Đã đọc lại các máy chủ.',
    stop: 'Ngừng nhận tài khoản mới',
    start: 'Nhận tài khoản mới',
    stopTitle: 'Ngừng nhận tài khoản mới trên {{server}}',
    startTitle: 'Nhận tài khoản mới trên {{server}}',
    acceptingIntro: 'Tài khoản mới được xếp vào máy chủ còn nhận và ít tải nhất; tài khoản đang có trên máy chủ này giữ nguyên.',
    note: 'Ghi chú (hiện ở máy chủ)',
    acceptingDone: 'Đã lưu.',
    accounts: 'Tài khoản trên máy chủ',
    accountsHint: 'Đọc trực tiếp từ máy chủ khi bấm, từng trang. "Chưa có trong hệ thống" là tài khoản máy chủ đang giữ mà không thuộc dịch vụ nào của hệ thống.',
    accountCol: { username: 'Tên đăng nhập', domain: 'Tên miền', status: 'Trên máy chủ', plan: 'Gói', service: 'Trong hệ thống', customer: 'Khách hàng' },
    status: { PROVISIONING: 'Đang tạo', ACTIVE: 'Đang chạy', SUSPENDED: 'Đang tạm ngưng', TERMINATED: 'Đã xoá', FAILED: 'Lỗi', UNKNOWN: 'Chưa rõ' },
    notInSystem: 'Chưa có trong hệ thống',
    openService: 'Mở dịch vụ',
    load: 'Đọc từ máy chủ',
    more: 'Trang sau',
    packages: 'Gói trên máy chủ',
    packagesHint: 'Những tên gói mà "gói bên nhà cung cấp" của một gói bán có thể dùng (Sản phẩm & giá › gói › Cấp phát).',
    loadPackages: 'Đọc từ máy chủ',
    packageCol: { code: 'Mã gói', name: 'Gói trên máy chủ', limits: 'Giới hạn' },
    meter: { DISK_MB: 'Đĩa (MB)', BANDWIDTH_MB: 'Băng thông (MB)', DATABASES: 'Cơ sở dữ liệu', MAILBOXES: 'Hộp thư' },
    unlimited: 'không giới hạn',
  },
  capability: {
    'addons.admin': 'Trang cho nhân viên',
    'addons.api': 'Đường dẫn API riêng',
    'addons.client_area': 'Trang cho khách hàng',
    'addons.events': 'Nhận sự kiện của hệ thống',
    'addons.jobs': 'Việc chạy theo lịch',
    'addons.storage': 'Kho dữ liệu riêng',
    'captcha.risk': 'Điểm rủi ro',
    'cloud.backups': 'Sao lưu',
    'cloud.console': 'Màn hình điều khiển máy chủ',
    'cloud.credentials': 'Thông tin truy cập',
    'cloud.firewalls': 'Tường lửa',
    'cloud.inventory': 'Liệt kê máy chủ đang có',
    'cloud.ips': 'Thêm địa chỉ IP',
    'cloud.plans': 'Gói dịch vụ và giá',
    'cloud.renewals': 'Gia hạn ở nhà cung cấp',
    'cloud.reverse_dns': 'DNS ngược',
    'cloud.snapshots': 'Bản chụp nhanh',
    'cloud.ssh_keys': 'Khoá SSH',
    'cloud.sso': 'Đăng nhập không cần mật khẩu',
    'cloud.usage': 'Mức sử dụng',
    'cloud.volumes': 'Thêm ổ đĩa',
    'dns.credentials': 'Thông tin truy cập',
    'dns.dnssec': 'Ký vùng DNS (DNSSEC)',
    'dns.inventory': 'Liệt kê vùng DNS đang có',
    'dns.native_templates': 'Mẫu của nhà cung cấp',
    'dns.plans': 'Gói dịch vụ và giá',
    'dns.propagation': 'Kiểm tra cập nhật DNS',
    'dns.renewals': 'Gia hạn ở nhà cung cấp',
    'dns.secondary': 'DNS phụ',
    'dns.sso': 'Đăng nhập không cần mật khẩu',
    'dns.stats': 'Thống kê truy vấn',
    'dns.usage': 'Mức sử dụng',
    'dns.zone_files': 'Tệp vùng DNS',
    'einvoice.adjust': 'Điều chỉnh hoá đơn',
    'einvoice.buyer_lookup': 'Tra cứu người mua theo mã số thuế',
    'einvoice.cancel': 'Huỷ hoá đơn',
    'einvoice.delivery': 'Gửi hoá đơn cho người mua',
    'einvoice.drafts': 'Hoá đơn nháp',
    'einvoice.payment_marking': 'Đánh dấu đã thanh toán',
    'einvoice.replace': 'Thay thế hoá đơn',
    'ekyc.chip': 'Đọc chip căn cước',
    'ekyc.liveness': 'Kiểm tra người thật',
    'email.aliases': 'Địa chỉ phụ',
    'email.credentials': 'Thông tin truy cập',
    'email.dkim': 'Ký DKIM',
    'email.domain_aliases': 'Tên miền phụ',
    'email.inventory': 'Liệt kê hộp thư đang có',
    'email.licences': 'Giấy phép sử dụng',
    'email.migration': 'Chuyển hộp thư',
    'email.plans': 'Gói dịch vụ và giá',
    'email.renewals': 'Gia hạn ở nhà cung cấp',
    'email.sso': 'Đăng nhập không cần mật khẩu',
    'email.usage': 'Mức sử dụng',
    'hosting.backups': 'Sao lưu và khôi phục',
    'hosting.databases': 'Cơ sở dữ liệu',
    'hosting.domains': 'Tên miền trên tài khoản',
    'hosting.ftp': 'Tài khoản FTP',
    'hosting.placement': 'Chọn máy chủ còn chỗ',
    'hosting.ssl': 'Chứng chỉ SSL',
    'hosting.credentials': 'Thông tin truy cập',
    'hosting.inventory': 'Liệt kê tài khoản đang có',
    'hosting.plans': 'Gói dịch vụ và giá',
    'hosting.renewals': 'Gia hạn ở nhà cung cấp',
    'hosting.sso': 'Đăng nhập không cần mật khẩu',
    'hosting.usage': 'Mức sử dụng',
    'notify.inbound': 'Nhận tin trả lời',
    'notify.quota': 'Xem hạn mức gửi',
    'notify.receipts': 'Báo đã nhận tin',
    'notify.templates': 'Mẫu tin của nhà cung cấp',
    'ocr.pdf': 'Đọc tệp PDF',
    'payment.accounts': 'Liệt kê tài khoản liên kết',
    'payment.bank_account': 'Tài khoản nhận tiền (QR chuyển khoản)',
    'payment.history': 'Đọc lịch sử để đối soát',
    'payment.ipn': 'Nhận báo tiền vào (IPN/webhook)',
    'payment.redirect': 'Trang thanh toán của cổng',
    'payment.refund': 'Hoàn tiền về nguồn',
    'payment.status': 'Tra trạng thái',
    'regulatory.business_registry': 'Tra cứu thông tin doanh nghiệp',
    'regulatory.change_reports': 'Báo cáo thay đổi',
    'regulatory.daily_tracking': 'Báo cáo theo dõi hằng ngày',
    'regulatory.deposit': 'Số dư ký quỹ',
    'regulatory.dossier_sync': 'Đồng bộ hồ sơ tên miền',
    'regulatory.maintained_list': 'Danh sách tên miền duy trì',
    'regulatory.places': 'Danh mục địa giới hành chính',
    'regulatory.promotion_codes': 'Mã khuyến mại',
    'signing.callbacks': 'Nhận kết quả ký do nhà cung cấp báo về',
    'signing.hash_signing': 'Ký trên mã băm của tệp',
    'website.backups': 'Sao lưu',
    'website.cms': 'Quản lý nội dung',
    'website.credentials': 'Thông tin truy cập',
    'website.editor': 'Trình chỉnh sửa website',
    'website.inventory': 'Liệt kê website đang có',
    'website.plans': 'Gói dịch vụ và giá',
    'website.renewals': 'Gia hạn ở nhà cung cấp',
    'website.ssl': 'Chứng chỉ SSL',
    'website.sso': 'Đăng nhập không cần mật khẩu',
    'website.staging': 'Bản thử website',
    'website.usage': 'Mức sử dụng',
    other: 'Khác ({{code}})',
  },
  errors: {
    failed: 'Không thực hiện được thay đổi',
    code: {
      UNKNOWN_BRANCH: 'Không có mảng nghiệp vụ này.',
      UNKNOWN_MODULE: 'Máy chủ này chưa cài module này.',
      UNKNOWN_INSTANCE: 'Không có kết nối này (có thể đã bị gỡ).',
      UNKNOWN_ACTION: 'Module không có thao tác này.',
      UNKNOWN_VERSION: 'Không có phiên bản này.',
      INSTANCE_EXISTS: 'Đã có kết nối dùng mã này.',
      INSTANCE_LIMIT: 'Module này không cho thêm kết nối.',
      NOT_A_DRAFT: 'Chỉ áp dụng được bản nháp hiện tại. Tải lại trang.',
      TEST_REQUIRED: 'Cần kiểm tra kết nối bản nháp này trước (đạt trong 24 giờ qua).',
      NO_TEST: 'Module này không có bước kiểm tra kết nối.',
      NOT_CONFIGURED: 'Hãy lưu bản nháp trước.',
      NOT_ACTIVE: 'Kết nối chưa được bật.',
      ALREADY_DISABLED: 'Kết nối đã tắt rồi.',
      ALREADY_ENABLED: 'Kết nối đã bật rồi.',
      PENDING_EXISTS: 'Đã có thay đổi của kết nối này đang chờ duyệt.',
      PENDING_CHANGE_EXISTS: 'Đã có thay đổi của kết nối này đang chờ duyệt.',
      CONCURRENT_CHANGE: 'Có người vừa thay đổi kết nối này. Tải lại trang.',
      TEST_RATE_LIMITED: 'Chờ vài giây rồi kiểm tra lại.',
      NOT_A_SWITCH: 'Cài đặt chung của mảng không bật hay tắt được.',
      SCHEDULE_FAILED: 'Không lên lịch được việc chạy định kỳ của module.',
      VALIDATION_FAILED: 'Một số cài đặt chưa hợp lệ:',
      other: 'Máy chủ không chấp nhận yêu cầu.',
    },
    field: {
      REQUIRED: 'Cần nhập',
      UNKNOWN_FIELD: 'Không phải cài đặt của module này',
      NOT_TEXT: 'Phải là chữ',
      TOO_LONG: 'Quá dài',
      PATTERN: 'Không đúng định dạng',
      NOT_IN_OPTIONS: 'Không có trong danh sách lựa chọn',
      NOT_A_LIST: 'Phải là danh sách lựa chọn',
      HTTPS_REQUIRED: 'Phải bắt đầu bằng https://',
      ADDRESS_NOT_ALLOWED: 'Không được dùng địa chỉ này (máy nội bộ hoặc mạng riêng)',
      INVALID_URL: 'Không phải địa chỉ web hợp lệ',
      URL_CREDENTIALS_FORBIDDEN: 'Địa chỉ không được chứa tên đăng nhập hay mật khẩu',
      URL_QUERY_FORBIDDEN: 'Địa chỉ không được chứa ? hoặc #',
      INVALID_PATH: 'Không phải đường dẫn bắt đầu bằng /',
      OUT_OF_RANGE: 'Ngoài khoảng cho phép',
      NOT_A_SWITCH: 'Phải là bật hoặc tắt',
      INVALID_TIME: 'Không phải giờ (giờ:phút)',
      INVALID_EMAIL: 'Không phải địa chỉ e-mail',
      INVALID_PHONE: 'Không phải số điện thoại kèm mã nước',
      INVALID_KEY: 'Chỉ dùng chữ thường, chữ số và dấu "-" (tối đa 40 ký tự)',
      SECRET_REQUIRED: 'Cần nhập giá trị hoặc chỗ lưu giá trị',
      SECRET_TOO_LONG: 'Quá dài',
      NOTHING_TO_KEEP: 'Không còn giá trị đã lưu để giữ: hãy nhập giá trị mới',
      ENV_REFERENCE_FORBIDDEN_IN_PRODUCTION: 'Máy chủ chính thức không dùng được biến môi trường của máy chủ',
      INVALID_SECRET_REFERENCE: 'Chỗ lưu không hợp lệ (env:, file: hoặc vault:)',
      DB_REFERENCE_NOT_ALLOWED: 'Hãy nhập chính giá trị thay vì chỗ lưu db:',
      RESERVED_SECRET_REFERENCE: 'Chỗ lưu này dành riêng cho hệ thống',
      NOT_PRODUCTION_READY: 'Module này chưa bật được trên máy chủ chính thức',
      // email/wildduck
      DUPLICATE_PLAN_CODE: 'Mã gói này trùng với mã của gói khác',
      // hosting/cpanel
      TLS_VERIFICATION_REQUIRED: 'Máy chủ chính thức luôn kiểm tra chứng chỉ SSL của máy chủ WHM',
      PACKAGE_MAP_INVALID: 'Ghi mỗi gói một cặp mã=tên gói WHM, cách nhau bằng dấu phẩy; không lặp mã hay tên gói',
      // cloud/proxmox
      NOT_A_HOST: 'Chỉ ghi tên máy hoặc địa chỉ IP, không có https://, đường dẫn hay cổng',
      NOT_A_TOKEN_ID: 'Mã token API có dạng NGƯỜI_DÙNG@REALM!TÊN_TOKEN, ví dụ tino@pve!platform',
      NOT_NODE_NAMES: 'Tên các nút trong cụm, cách nhau bằng dấu phẩy, ví dụ pve1, pve2',
      INVALID_FLAVORS: 'Mỗi gói một mục mã=vCPU/RAM MB/đĩa GB/băng thông GB, cách nhau bằng dấu chấm phẩy; không lặp mã',
      INVALID_IMAGES: 'Mỗi mẫu một mục mã=VMID của mẫu/tên/linux, windows hoặc app/đĩa tối thiểu GB, cách nhau bằng dấu chấm phẩy',
      INVALID_ADDRESS_RANGE: 'Ghi địa chỉ đầu-địa chỉ cuối cùng một loại, cả hai nằm trong cùng một mạng theo độ dài mạng',
      GATEWAY_OUTSIDE_NETWORK: 'Cổng mặc định không nằm trong mạng của dải địa chỉ',
      ADDRESS_RANGE_REQUIRED: 'Cần nhập dải IPv4 hoặc IPv6 để cấp cho máy',
      other: 'Module không chấp nhận ({{code}})',
    },
    warning: {
      title: 'Đã lưu, có lưu ý',
      PRIVATE_ADDRESS: 'Địa chỉ nằm trong mạng riêng: chỉ máy chủ trong mạng đó mới tới được.',
      PLAIN_HTTP: 'Địa chỉ không mã hoá (http://).',
      other: 'Lưu ý của module ({{code}})',
    },
    meta: 'Mã {{code}} · yêu cầu {{requestId}}',
  },
};
